import { NormalizedCacheObject } from 'apollo-boost';

import { executeRecommendationMutationInstance } from '../../graphql/mutations/grid/recommendations';
import { executeRecommendationMutation } from '../../typings/graphql-grid';
import { RecommendationKey } from '../../typings/recommendations';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export class RecommendationsMutationExecutor {
    constructor(private client: DNAApolloClient<NormalizedCacheObject>) {}

    public async executeRecommendation(keys: Array<RecommendationKey>): Promise<executeRecommendationMutation> {
        const result = await this.client.mutate<executeRecommendationMutation>({
            mutation: executeRecommendationMutationInstance,
            variables: {
                input: {
                    items: keys
                }
            }
        });

        return result.data as executeRecommendationMutation;
    }
}
